<h1 mat-dialog-title>{{ 'calibrateEquipmentEdit.dialog.signReport.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="calibrates-theme" style="overflow-y: hidden;">

    @if (showChangeLangIcon()) {
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'common.reportType.options.language.label' | translate }}</mat-label>
        <mat-select [(ngModel)]="reportConfig.lang" [ngModelOptions]="{standalone: true}">
          @for (item of langs; track item) {
            <mat-option [value]="item.lang">
              <mat-icon svgIcon="{{item.flag}}"></mat-icon>
              {{item.fullLang}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

  </div>

  <br /><br />

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()"
    cdkFocusInitial>{{ 'button.sign' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>